import http from "infra/http";
import { useMutation } from "react-query";
import { DespesaQuery } from "core/features/relatorios/typings";
import { PDFRelatorioDespesasResponse } from "core/features/relatorios/typings";

export function useDespesasPdf(filtro: DespesaQuery) {
  return useMutation(
    [`/v1/relatorios/financeiro/despesas/pdf`, filtro],
    async () => {
      const url = "/v1/relatorios/financeiro/despesas/pdf";

      const { data } = await http.get<PDFRelatorioDespesasResponse>(url, {
        params: filtro,
      });

      return data;
    }
  );
}
